export default null;

export enum score {
  Poor = 1,
  Fair,
  Good,
  VeryGood,
  Excellent,
}
